import { AnyAction, configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { ThunkAction } from 'redux-thunk'
import { resetActiveEntityOnChange } from 'src/v3/create/create.slice'
import { fetchClassesOnSectionChange as _fetchClassesOnSectionChange } from 'src/v3/self-paced/self-paced.slice'
import { fetchEntitiesOnUsersFetched } from 'src/v3/admin/admin.slice'
import { validateProfileOnChange } from 'src/v3/classroom/classroom.slice'
import { resetCreateEntityOnEdit } from 'src/v3/create/create.middleware'
import { listenerMiddleware as pipelineListenerMiddleware } from 'src/v3/content-pipeline/pipeline.middleware'
import { listenerMiddleware as profileListenerMiddleware } from 'src/v3/profile/profile.middleware'
import { listenerMiddleware as manageListenerMiddleware } from 'src/v3/manage/manage.middleware'
import { listenerMiddleware as codexListenerMiddleware } from 'src/v3/codex/codex.middleware'
import { listenerMiddleware as classroomV2ListenerMiddleware } from 'src/v3/classroom-v2/classroom-v2.middleware'
import { listenerMiddleware as eventsV2ListenerMiddleware } from 'src/v3/events/v2/events-v2.middleware'

import rootReducer, { RootState } from './root-state'

export type Status = 'uninitialized' | 'pending' | 'fulfilled' | 'rejected'

export const store = configureStore({
  reducer: rootReducer,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore - Redux Toolkit v2 middleware type inference issue
  middleware:
    import.meta.env.VITE_LOG_LEVEL === 'debug'
      ? (getDefaultMiddleware) =>
          getDefaultMiddleware().concat([
            _fetchClassesOnSectionChange,
            resetActiveEntityOnChange,
            resetCreateEntityOnEdit,
            fetchEntitiesOnUsersFetched,
            validateProfileOnChange,
            logger,
            pipelineListenerMiddleware.middleware,
            profileListenerMiddleware.middleware,
            manageListenerMiddleware.middleware,
            codexListenerMiddleware.middleware,
            classroomV2ListenerMiddleware.middleware,
            eventsV2ListenerMiddleware.middleware,
          ])
      : (getDefaultMiddleware) =>
          getDefaultMiddleware().concat([
            _fetchClassesOnSectionChange,
            resetActiveEntityOnChange,
            resetCreateEntityOnEdit,
            fetchEntitiesOnUsersFetched,
            validateProfileOnChange,
            pipelineListenerMiddleware.middleware,
            profileListenerMiddleware.middleware,
            manageListenerMiddleware.middleware,
            codexListenerMiddleware.middleware,
            classroomV2ListenerMiddleware.middleware,
            eventsV2ListenerMiddleware.middleware,
          ]),
})

export type AppThunk = ThunkAction<
  Promise<void> | void,
  RootState,
  unknown,
  AnyAction
>
export type AppRootState = RootState
export type AppDispatch = typeof store.dispatch
